import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
    selector: `[modTopNavOffset]`,
})
export class TopNavOffsetModifierDirective {
    @Input() @HostBinding("style.top.px") public modTopNavOffsetValue = 70;
}
